// extracted by mini-css-extract-plugin
module.exports = {"burger":"BurgerMenu_burger__15wnS","mobileMenu":"BurgerMenu_mobileMenu__12rTm","mobileNav":"BurgerMenu_mobileNav__2LHaC","active":"BurgerMenu_active__207vz"};